export function setupSharedLinks(el) {
  const sharedMask = el.nextSibling

  if (sharedMask.dataset.checked) {
    return;
  }

  sharedMask.dataset['checked'] = true

  const postTitle = sharedMask.dataset.title
  const postLink  = sharedMask.dataset.link
  const postImage = sharedMask.dataset.image

  const facebookEl = sharedMask.querySelector('.facebook')
  facebookEl.addEventListener("click", (e) => {
    window.trackingEvent.share({
      method: 'facebook',
      content_type: 'post',
      item_id: postLink,
    })
    FB.ui({
      method: "share",
      href: postLink,
    })
  })

  const twitterEl = sharedMask.querySelector('.twitter')
  twitterEl.addEventListener("click", (e) => {
    window.trackingEvent.share({
      method: 'twitter',
      content_type: 'post',
      item_id: postLink,
    })
    window.open(
      `https://twitter.com/share?url=${encodeURIComponent(postLink)}&text=${postTitle}`,
      "_blank"
    )
  })

  const redditEl = sharedMask.querySelector('.reddit')
  redditEl.addEventListener("click", (e) => {
    window.trackingEvent.share({
      method: 'reddit',
      content_type: 'post',
      item_id: postLink,
    })
    window.open(
      `https://reddit.com/submit?url=${encodeURIComponent(postLink)}&title=${postTitle}`,
      "_blank"
    )
  })

  const pinterestEl = sharedMask.querySelector('.pinterest')
  pinterestEl.addEventListener("click", (e) => {
    window.trackingEvent.share({
      method: 'pinterest',
      content_type: 'post',
      item_id: postLink,
    })
    window.open(
      `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(postLink)}&media=${encodeURIComponent(postImage)}&description=${encodeURIComponent(postTitle)}`,
      "_blank"
    )
  })

  const whatsappEl = sharedMask.querySelector('.whatsapp')
  whatsappEl.addEventListener("click", (e) => {
    window.trackingEvent.share({
      method: 'whatsapp',
      content_type: 'post',
      item_id: postLink,
    })
    window.location.href = "https://api.whatsapp.com/send?text=" + postLink
  })

  const emailEl = sharedMask.querySelector('.email')
  emailEl.addEventListener("click", (e) => {
    window.location.href = `mailto:?subject=${postTitle}&body=${postLink}`
  })

  const copyLinkEl = sharedMask.querySelector('.link')
  copyLinkEl.addEventListener("click", (e) => {
    e.target.firstElementChild.style.visibility = "visible"
    setTimeout(function () {
      e.target.firstElementChild.style.visibility = "hidden"
    }, 1000)

    const copyArea = postLink
    navigator.clipboard.writeText(copyArea)
  })
}